import axios from 'axios';
import { setupInterceptorsTo } from '../Componentes/API/AxiosBuilder';
import { RUTA_API_USUARIOS } from '../Contantes/Constantes';

export default function useTranslationService() {
    const axiosInstance = setupInterceptorsTo(
        axios.create({
            headers: {
                "Content-Type": "application/json",
            },
        })
    );

    const getUsers = async () => {
        const config = {
            method: 'GET',
            url: `${RUTA_API_USUARIOS}/keycloak/users`,
        };
        return axiosInstance(config)
            .then(response => response.data)
            .catch(error => ({
                success: false,
                error: error.response?.data || {
                    code: 'UNKNOWN_ERROR',
                    details: 'An unknown error occurred',
                },
            }));
    };

    const getUserByUsername = async (username) => {
        const config = {
            method: 'GET',
            url: `${RUTA_API_USUARIOS}/keycloak/users/${encodeURIComponent(username)}`,
        };
        return axiosInstance(config)
            .then(response => response.data)
            .catch(error => ({
                success: false,
                error: error.response?.data || {
                    code: 'UNKNOWN_ERROR',
                    details: 'An unknown error occurred',
                },
            }));

    }

    const getRoles = async () => {
        const config = {
            method: 'GET',
            url: `${RUTA_API_USUARIOS}/keycloak/roles`,
        };
        return axiosInstance(config)
            .then(response => response.data)
            .catch(error => ({
                success: false,
                error: error.response?.data || {
                    code: 'UNKNOWN_ERROR',
                    details: 'An unknown error occurred',
                },
            }));
    };

    const getUserRoles = async (userId) => {
        const config = {
            method: 'GET',
            url: `${RUTA_API_USUARIOS}/keycloak/roles/${userId}`,
        };
        return axiosInstance(config)
            .then(response => response.data)
            .catch(error => ({
                success: false,
                error: error.response?.data || {
                    code: 'UNKNOWN_ERROR',
                    details: 'An unknown error occurred',
                },
            }));
    };

    const getAreaRoles = async (areaId) => {
        const config = {
            method: 'GET',
            url: `${RUTA_API_USUARIOS}/keycloak/roles/area/${areaId}`,
        };
        return axiosInstance(config)
            .then(response => response.data)
            .catch(error => ({
                success: false,
                error: error.response?.data || {
                    code: 'UNKNOWN_ERROR',
                    details: 'An unknown error occurred',
                },
            }));
    };

    return {
        getRoles,
        getUsers,
        getUserByUsername,
        getUserRoles,
        getAreaRoles
    }
}